import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

import { computed, observable, makeObservable, runInAction } from "mobx";
import { persist } from "mobx-persist";
import * as yup from "yup";

var _SCHEMA = yup.object({
  customAmount: yup.number().when(["customMaxGratuityValue"], {
    is: function is(customMaxGratuityValue) {
      return customMaxGratuityValue > 0;
    },
    then: yup.number().transform(function (value) {
      return isNaN(value) ? 0 : value;
    }).max(yup.ref("customMaxGratuityValue"))
  })
});

var GratuityModel = (_class = /*#__PURE__*/function () {
  function GratuityModel(platformUtil) {
    _classCallCheck(this, GratuityModel);

    _initializerDefineProperty(this, "_addGratuity", _descriptor, this);

    _initializerDefineProperty(this, "_customAmount", _descriptor2, this);

    _initializerDefineProperty(this, "_selectedTipPercentage", _descriptor3, this);

    _initializerDefineProperty(this, "_showCustomAmount", _descriptor4, this);

    _initializerDefineProperty(this, "_minTipPercentage", _descriptor5, this);

    _initializerDefineProperty(this, "_maxTipPercentage", _descriptor6, this);

    _initializerDefineProperty(this, "_tipLabelStep", _descriptor7, this);

    _initializerDefineProperty(this, "_customMaxGratuityValue", _descriptor8, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor9, this);

    _defineProperty(this, "platformUtil", void 0);

    makeObservable(this);
    this.platformUtil = platformUtil;
  }

  _createClass(GratuityModel, [{
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this = this;

      var customMaxThreshold = this.customMaxGratuityValue.toFixed(2);
      appMessages.showError("Please review gratuity added", "The gratuity added to this check online may not exceed $" + customMaxThreshold + ". We appreciate your generosity but please adjust the gratuity or see your server for further assistance.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this.platformUtil.scrollToElement(_this.componentRef);
        }
      });
    }
  }, {
    key: "errors",
    get: function get() {
      return {};
    }
  }, {
    key: "addGratuity",
    get: function get() {
      return this._addGratuity;
    },
    set: function set(_addGratuity) {
      var _this2 = this;

      runInAction(function () {
        _this2._addGratuity = _addGratuity;
      });
    }
  }, {
    key: "customAmount",
    get: function get() {
      return this._customAmount;
    },
    set: function set(_customAmount) {
      this._customAmount = _customAmount;
    }
  }, {
    key: "selectedTipPercentage",
    get: function get() {
      return this.addGratuity ? this._selectedTipPercentage : 0;
    },
    set: function set(_selectedTipPercentage) {
      this._selectedTipPercentage = _selectedTipPercentage;
    }
  }, {
    key: "showCustomAmount",
    get: function get() {
      return this._showCustomAmount;
    },
    set: function set(_showCustomAmount) {
      var _this3 = this;

      runInAction(function () {
        _this3._showCustomAmount = _showCustomAmount;
      });
    }
  }, {
    key: "minTipPercentage",
    get: function get() {
      return this._minTipPercentage;
    },
    set: function set(_minTipPercentage) {
      this._minTipPercentage = _minTipPercentage;
    }
  }, {
    key: "tipSteps",
    get: function get() {
      var steps = [];

      for (var i = 0; i < this.maxTipPercentage; i++) {
        var stepVal = this.minTipPercentage + this.tipLabelStep * i;

        if (stepVal <= this.maxTipPercentage) {
          steps.push(stepVal);
        } else {
          break;
        }
      }

      return steps;
    }
  }, {
    key: "maxTipPercentage",
    get: function get() {
      return this._maxTipPercentage;
    },
    set: function set(_maxTipPercentage) {
      this._maxTipPercentage = _maxTipPercentage;
    }
  }, {
    key: "tipLabelStep",
    get: function get() {
      return this._tipLabelStep;
    },
    set: function set(_tipLabelStep) {
      this._tipLabelStep = _tipLabelStep;
    }
  }, {
    key: "tipAmount",
    get: function get() {
      var ret = 0;

      if (this.addGratuity) {
        if (this._showCustomAmount) {
          ret = parseFloat(this._customAmount);

          if (isNaN(ret)) {
            ret = 0;
          }
        } else {
          ret = this._selectedTipPercentage;
        }
      }

      return ret;
    }
  }, {
    key: "customMaxGratuityValue",
    get: function get() {
      return this._customMaxGratuityValue;
    },
    set: function set(_customMaxGratuityValue) {
      this._customMaxGratuityValue = _customMaxGratuityValue;
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this4 = this;

      runInAction(function () {
        _this4._componentRef = _componentRef;
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }]);

  return GratuityModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_addGratuity", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_customAmount", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_selectedTipPercentage", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0.0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showCustomAmount", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_minTipPercentage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_maxTipPercentage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_tipLabelStep", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_customMaxGratuityValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addGratuity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addGratuity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedTipPercentage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedTipPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCustomAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCustomAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minTipPercentage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minTipPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tipSteps", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tipSteps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxTipPercentage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxTipPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tipLabelStep", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tipLabelStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tipAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tipAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customMaxGratuityValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "customMaxGratuityValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype)), _class);
export { GratuityModel as default };